const adminSettingMultiLanguageStyle = (theme) => ({
    item: {
        marginTop: '15px',
    },
    room: {
        padding: '20px 20px 20px 0',
        marginBottom: '50px',
    },
    itemAlignRight: {
        textAlign: 'end',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'start',
        },
    },
    buttonSubmit: {
        textAlign: 'center',
    },
});

export default adminSettingMultiLanguageStyle;
